//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import PrivacyPolicy from '~/components/legal/PrivacyPolicy.vue'
import PrivacyPolicyBR from '~/components/legal/PrivacyPolicyBR.vue'
import CookiePolicy from '~/components/legal/CookiePolicy.vue'
import BRCyberSecurityPolicy from '~/components/legal/BRCyberSecurity.vue'
import ENLGPD from '~/components/legal/ENLGPD.vue'
import BRGC from '~/components/legal/BRGovCorp.vue'
import BRPLD from '~/components/legal/BRPrevLavDin.vue'
import CPICert from '~/components/legal/CPICert.vue'
/* Lazy load components */
const TermsBR = () => import(/* webpackChunkName: "RestAct" */ '@/components/legal/TermsBR.vue')
const TermsPolicies = () => import(/* webpackChunkName: "RestAct" */ '@/components/legal/TermsPolicies.vue')
const RestAct = () => import(/* webpackChunkName: "RestAct" */ '@/components/legal/RestrictedAct.vue')
const RestActBR = () => import(/* webpackChunkName: "RestActBR" */ '@/components/legal/RestrictedActBR.vue')
const RestActZH = () => import(/* webpackChunkName: "RestActZH" */ '@/components/legal/RestrictedActZH.vue')
const RestActES = () => import(/* webpackChunkName: "RestActES" */ '@/components/legal/RestrictedActES.vue')

export default {
  components: {
    TopScreen,
    FooterTop,
    TermsPolicies,
    PrivacyPolicy,
    CookiePolicy,
    BRCyberSecurityPolicy,
    ENLGPD,
    BRGC,
    BRPLD,
    RestAct,
    RestActBR,
    RestActZH,
    RestActES,
    CPICert,
    TermsBR,
    PrivacyPolicyBR
  },
  data () {
    return {
      activeItem: 1,
      activeComponent: this.$i18n.locale === 'pt' ? TermsBR : TermsPolicies
    }
  },
  head () {
    return {
      title: this.$t('footer.about.legal').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  computed: {
    getTermsAndConditions () {
      const component = this.$i18n.locale === 'pt' ? TermsBR : TermsPolicies
      return component
    },
    getRestrictedActivities () {
      const component = this.$i18n.locale === 'zh' ? RestActZH : this.$i18n.locale === 'es' ? RestActES : this.$i18n.locale === 'pt' ? RestActBR : RestAct
      return component
    }
  },
  methods: {
    changeComponent ($event, item) {
      $event.preventDefault()
      if (item >= 1 && item <= 10 && this.activeItem !== item) {
        if (item === 1) {
          this.activeComponent = this.getTermsAndConditions
        } else if (item === 2) {
          this.activeComponent = PrivacyPolicy
        } else if (item === 3) {
          this.activeComponent = CookiePolicy
        } else if (item === 4) {
          this.activeComponent = BRCyberSecurityPolicy
        } else if (item === 5) {
          this.activeComponent = ENLGPD
        } else if (item === 6) {
          this.activeComponent = PrivacyPolicyBR
        } else if (item === 7) {
          this.activeComponent = BRGC
        } else if (item === 8) {
          this.activeComponent = BRPLD
        } else if (item === 9) {
          this.activeComponent = this.getRestrictedActivities
        } else if (item === 10) {
          this.activeComponent = CPICert
        }
        this.activeItem = item
      }
    }
  }
}
